import Head from 'next/head';
import Footer from '../common/Footer';
import Nav from '../common/nav';

export default function WhoIsThisFor() {
  return (
    <>
      <Head>
        <title>Who is it for? | Gwak</title>
        <meta
          name="description"
          content="For people looking for a better restaurant discovery experience."
        />
      </Head>
      <Nav/>
      <section>
        <img
          className="absolute top-0 left-0 mt-24 hidden lg:block"
          src="/page-assets/icons/dots/blue-dot-left-bars.svg"
          alt=""
        />
        <img
          className="absolute top-0 right-0 mt-40 hidden lg:block"
          src="/page-assets/icons/dots/yellow-dot-right-shield.svg"
          alt=""
        />
        <div className="container mx-auto px-4">
          <div className="mx-auto max-w-2xl">
            <h2 className="font-heading mb-10 text-4xl font-semibold">
              Who is this for?
            </h2>
            <p className="mb-2 text-xl text-gray-500">
              If you&apos;re anything like me, you may have experienced any or all of
              the situations below:
            </p>
            <ul
              role="list"
              className="ml-6 mb-6 list-inside list-disc space-y-2 text-xl italic text-gray-500 marker:text-blue-500"
            >
              <li>
                You&apos;re in a new city and you need to triangulate the &quot;best&quot;
                place to eat between Yelp, Google Maps, Instagram, Tik Tok,
                Foursquare, etc that fits the groups&apos; tastes.
              </li>
              <li>
                You&apos;re in a new country and Yelp isn&apos;t available, so you resort
                to Tripadvisor.
              </li>
              <li>
                Your friend recommends some places to eat and you take a note in
                your phone only for it to never be looked at again.
              </li>
              <li>
                You and some friends try to create and maintain a Google
                Spreadsheet of restaurant recommendations, but it&apos;s a pain to
                maintain.
              </li>
              <li>
                Out of town folks ask for some restaurant recommendations and
                you need to write an essay you&apos;ve written many times before.
              </li>
              <li>
                You found a gem of a place, but only told one friend about it.
              </li>
              <li>
                You realize you and another friend have a lot of similar tastes
                and you would go anywhere they recommend.
              </li>
              <li>
                You know a go-to spot that punches well above what its ratings
                would suggest.
              </li>
            </ul>
            <p className="mb-6 text-xl text-gray-500">
              If any of the above apply to you, then I encourage you to try Gwak
              and experience a more seamless and human-curated sharing of
              restaurants.
            </p>
            <p className="mb-2 text-xl text-gray-500">With Gwak, you can:</p>
            <ul className="ml-6 mb-6 list-inside list-disc space-y-2 text-xl text-gray-500 marker:text-blue-500">
              <li>
                <b>Find interesting restaurants</b> from the people you choose
                to follow
              </li>
              <li>
                Write your reviews once and <b>share it with anyone</b>
              </li>
              <li>
                <b>Find other like-minded people</b> who share similar tastes
              </li>
              <li>
                <b>Silently unfollow</b> people when you no longer want to see
                their reviews
              </li>
            </ul>
          </div>
        </div>
      </section>
      <Footer/>
    </>
  );
}
